<script lang="ts" setup>
import { PrimaryButton } from '@hfc/ui-core';
import { useUrlHelper } from '@/page/infrastructure/composition/useUrlHelper';
import TextAndImage from '@/page/infrastructure/components/TextAndImage.vue';

const { getBaseUrl, getIaFQuoteUrl } = useUrlHelper();
</script>

<template>
  <TextAndImage div-class="pb-0" content-direction="right">
    <template #text>
      <div class="flex flex-col justify-center space-y-6">
        <span class="text-2xl lg:text-3xl font-bold text-slate-700">What is a qualified health plan?</span>
        <p>
          For Californians to be in compliance with the mandate, they’ll need to be enrolled on a qualified health
          plan that meets the government’s requirements for minimum essential coverage. The main coverage
          requirement is that the insurance must cover the 10 minimum essential benefits, such as preventive services,
          <a :href="getBaseUrl('/covered-california/prescription-drug-benefits')" class="text-blue-500 hover:underline">Prescription Drug Coverage</a>,
          and maternity and newborn care. A medical plan can still be a qualified health plan without the minimum
          essential benefits if the plan is a
          <a :href="getBaseUrl('/covered-california/grandfathered-plans')" class="text-blue-500 hover:underline">grandfathered plan</a>,
          which is a medical plan that was in force before March 23, 2010 when the mandate was passed and which has
          not undergone major changes. Qualified health plans may be acquired through Covered California,
          <a :href="getBaseUrl('/covered-california/health-insurance-companies/medi-cal')" class="text-blue-500 hover:underline">Medi-Cal</a>,
          Medicare, group insurance, a plan through the military, or off-exchange directly through the carrier.
        </p>
      </div>
    </template>
    <template #image>
      <div class="flex flex-1 justify-center pb-16 lg:pb-0">
        <img class="flex rounded" src="https://s3-us-west-1.amazonaws.com/hp-prod-wp-data/content/uploads/doctor-prescribe.png">
      </div>
    </template>
  </TextAndImage>
  <div class="max-w-7xl mx-auto md:px-6 py-16">
    <div class="flex flex-row justify-center">
      <PrimaryButton label="Get My Free Quote Now" size="lg" :href="getIaFQuoteUrl()" />
    </div>
  </div>
</template>
